import React from 'react';
import { SimpleForm, Create, TextInput, BooleanInput } from 'react-admin';
import { required } from 'ra-core';
import ScreenDescription from '../ScreenDescription';

const BlockCreate = props => (
  <>
    <ScreenDescription>
      Crie um bloco novo só se nenhum dos existentes fizer sentido pro fluxo que você quer classificar — na maioria dos casos,
      reclassificar uma fonte pra um bloco já existente é o caminho certo.
    </ScreenDescription>
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="key" label="Chave" validate={required()} />
        <BooleanInput source="active" label="Ativo" defaultValue={true} />
      </SimpleForm>
    </Create>
  </>
);

export default BlockCreate;
